/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// import Honeybadger from '@honeybadger-io/js';
//
// Honeybadger.configure({
//     apiKey: 'hbp_9KZy4PoPenebIktzZ3H0GfVgIJmYBm079QxT',
//     environment: process.env.NODE_ENV,
//     developmentEnvironments: ['development', 'local', 'test'],
// });

// import Sentry from '@sentry/browser';

// Sentry.init({
//     environment: process.env.NODE_ENV,
//     // release: "my-project-name@" + process.env.npm_package_version
// });

// if(window.User) {
//     try {
//         Sentry.setUser(window.User);
//     } catch (e) {
//         console.log(e);
//     }
// }

import ClipboardJS from "clipboard";

window.ClipboardJS = ClipboardJS;

document.addEventListener("DOMContentLoaded", function() {
    new ClipboardJS('.btn-copy');
});

require('./bootstrap');

document.addEventListener('DOMContentLoaded', function () {
    let page = document.querySelector("html, body");

    const calcNavigationItem = function () {
        let scrollPosition = page.scrollTop || document.documentElement.scrollTop;

        let helpNavigationLinks = document.querySelectorAll(".help-navigation a");

        for (let i = 0; i < helpNavigationLinks.length; i++) {
            let currentBlockId = helpNavigationLinks[i].getAttribute('href');
            let currentSection = document.querySelector(currentBlockId);
            if (currentSection) {
                let currentSectionPosition = currentSection.offsetTop - 15;

                if (i === helpNavigationLinks.length - 1) {
                    if (scrollPosition >= currentSectionPosition) {
                        helpNavigationLinks.forEach(link => link.classList.remove('active'));
                        helpNavigationLinks[i].classList.add('active');

                        // window.location.hash = helpNavigationLinks[i].getAttribute('href');
                    }
                } else {
                    let nextBlockId = helpNavigationLinks[i + 1].getAttribute('href');
                    let nextSection = document.querySelector(nextBlockId);
                    if (nextSection) {
                        let nextSectionPosition = nextSection.offsetTop - 15;

                        if (i === 0) {
                            if (scrollPosition < nextSectionPosition) {
                                helpNavigationLinks.forEach(link => link.classList.remove('active'));
                                helpNavigationLinks[i].classList.add('active');

                                // window.location.hash = helpNavigationLinks[i].getAttribute('href');
                            }
                        } else {
                            if (scrollPosition >= currentSectionPosition && scrollPosition < nextSectionPosition) {
                                helpNavigationLinks.forEach(link => link.classList.remove('active'));
                                helpNavigationLinks[i].classList.add('active');

                                // window.location.hash = helpNavigationLinks[i].getAttribute('href');
                            }
                        }
                    } else {
                        // console.error("Элемент", nextBlockId, "не найден на странице");
                    }
                }
            } else {
                // console.error("Элемент", currentBlockId, "не найден на странице");
            }
        }
    }

    window.addEventListener("scroll", function () {
        // page.scrollTop = page.scrollTop;
        // page.scrollLeft = page.scrollLeft;

        calcNavigationItem();
    });

    let scrollToLinks = document.querySelectorAll(".scroll-to");
    scrollToLinks.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            let section = this.getAttribute('href');

            let sectionElement = document.querySelector(section);
            if (sectionElement) {
                // window.location.hash = section;

                let sectionTop = sectionElement.offsetTop - 15;
                page.scrollTo({
                    top: sectionTop,
                    behavior: 'smooth'
                });

                calcNavigationItem();
            } else {
                // console.error("Элемент", section, "не найден на странице");
            }
        });
    });
});
